import { StatusBar, Style } from '@capacitor/status-bar';

export const setupStatusBar = async () => {
	try {
		const info = await StatusBar.getInfo();
		console.log('Status Bar Info:', info);
		// await StatusBar.show();

		await StatusBar.setStyle({ style: Style.Light });
	} catch (error) {
		console.error('Error setting status bar color:', error);
	}
};
